

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalProjectsCount }}</span>
          <span class="stats-card-label">Total Projects</span>
          <span class="stats-card-sublabel">With invoice data</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-file-export"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ monthlyCount }}</span>
          <span class="stats-card-label">Monthly</span>
          <span class="stats-card-sublabel">Monthly invoicing</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-calendar"></i></div>
      </div>
      <div class="stats-card stats-card--warning">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ milestoneCount }}</span>
          <span class="stats-card-label">Milestone</span>
          <span class="stats-card-sublabel">Project milestone</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-flag"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ showingCount }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After search</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="invoiceTypeFilter" class="filter-label">Invoicing Type</label>
          <p-multiSelect
            id="invoiceTypeFilter"
            [(ngModel)]="selectedInvoiceTypes"
            (ngModelChange)="onInvoiceTypeFilterChange()"
            [options]="invoiceTypeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="invoiceStatusFilter" class="filter-label">Invoice Status</label>
          <p-multiSelect
            id="invoiceStatusFilter"
            [(ngModel)]="selectedInvoiceStatuses"
            (ngModelChange)="onInvoiceStatusFilterChange()"
            [options]="invoiceStatusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="pmFilter" class="filter-label">PM</label>
          <p-multiSelect
            id="pmFilter"
            [(ngModel)]="selectedPMs"
            (ngModelChange)="onPMFilterChange()"
            [options]="pmFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search PM..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="serviceGroupFilterGrid" class="filter-label">Service Group</label>
          <p-multiSelect
            id="serviceGroupFilterGrid"
            [(ngModel)]="selectedServiceGroups"
            (ngModelChange)="onServiceGroupFilterChange()"
            [options]="serviceGroupFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search service group..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="accountManagerFilterGrid" class="filter-label">Account Manager</label>
          <p-multiSelect
            id="accountManagerFilterGrid"
            [(ngModel)]="selectedAccountManagers"
            (ngModelChange)="onAccountManagerFilterChange()"
            [options]="accountManagerFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search account manager..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>

        <div class="filter-field">
          <label for="clientFilterGrid" class="filter-label">Client</label>
          <p-multiSelect
            id="clientFilterGrid"
            [(ngModel)]="selectedClients"
            (ngModelChange)="onClientFilterChange()"
            [options]="clientFilterOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="All"
            [maxSelectedLabels]="2"
            [showToggleAll]="true"
            [filter]="true"
            filterPlaceholder="Search client..."
            appendTo="body"
            panelStyleClass="filter-dropdown-panel"
            styleClass="filter-select" />
        </div>
      </div>

      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <div class="invoice-grid-note" *ngIf="!loading">
      <i class="pi pi-info-circle"></i>
      <span>
        Month figures are the <strong>planned</strong> total of all milestones scheduled that
        month, across every invoicing status. For amounts actually billed, see
        <strong>Invoiced</strong> on a project's Payment Tracking tab.
      </span>
    </div>

    <div class="invoice-grid-container" *ngIf="!loading">
      <p-table
        [value]="filteredProjects"
        styleClass="p-datatable no-column-lines invoice-summary-table table-no-xscroll"
        [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
        [scrollable]="true"
        scrollHeight="flex"
        [paginator]="false">
        
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="project.name" class="col-project-name">
              Project Name
              <p-sortIcon field="project.name" />
            </th>
            <th pSortableColumn="invoiceType" class="col-invoice-type">
              Invoicing Type
              <p-sortIcon field="invoiceType" />
            </th>
            <th *ngFor="let month of months"
                (click)="openCalendarDialog(month.value)"
                [pTooltip]="month.fullName"
                class="month-header col-month">
              {{ month.label }}
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-projectData>
          <tr>
            <td class="project-name-cell" [pTooltip]="projectData.project.name" tooltipPosition="top">
              <span class="project-name-text">{{ projectData.project.name }}</span>
              <i *ngIf="projectData.undatedCount > 0"
                 class="pi pi-exclamation-triangle undated-warning"
                 [pTooltip]="getUndatedWarning(projectData)"
                 tooltipPosition="top"
                 aria-hidden="true"></i>
            </td>
            <td class="invoice-type-cell">
              <p-tag
                *ngIf="projectData.invoiceType !== undefined"
                [value]="projectData.invoiceTypeName || 'Monthly'"
                [severity]="getInvoiceTypeSeverity(projectData.invoiceType || InvoiceType.Monthly)" />
            </td>
            <td *ngFor="let month of months"
                class="month-cell text-center"
                (click)="openCalendarDialog(month.value)"
                [pTooltip]="getMonthTooltip(projectData, month.value)"
                [class.has-invoices]="projectData.monthlyData[month.value]?.count > 0"
                [ngClass]="getMonthCellClass(projectData, month.value)">
              <span *ngIf="projectData.monthlyData[month.value]?.count > 0"
                    class="invoice-percentage">
                {{ getMonthPercentage(projectData, month.value) }}
              </span>
              <span *ngIf="projectData.monthlyData[month.value]?.count === 0" class="no-data">-</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr class="table-empty-row">
            <td [attr.colspan]="14" class="table-empty-cell">
              <div class="empty-state">
                <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                <p class="empty-message">No invoice planning data found</p>
                <p class="empty-description">Try changing the year in the header or search by project name</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="loading" class="loading-container loading-container--centered">
      <i class="pi pi-spin pi-spinner loading-spinner-icon"></i>
      <p>Loading invoice planning data...</p>
    </div>
  </div>
</div>

<!-- Calendar Dialog -->
<p-dialog
  header="Invoice Calendar - {{ getCalendarMonthName() }} {{ selectedYearForCalendar }}"
  [(visible)]="showCalendarDialog"
  [modal]="true"
  [style]="{ width: 'auto', maxWidth: '520px', minWidth: '480px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="closeCalendarDialog()"
  styleClass="calendar-dialog"
  [contentStyle]="{ 'overflow': 'visible', 'padding': '0' }">
  
  <div class="calendar-dialog-content compact">
    <!-- Month Navigation -->
    <div class="calendar-navigation mb-3">
      <p-button
        icon="pi pi-chevron-left"
        (onClick)="navigateCalendarMonth(-1)"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Previous Month'"
        size="small" />
      <span class="calendar-month-year">{{ getCalendarMonthName() }} {{ selectedYearForCalendar }}</span>
      <p-button
        icon="pi pi-chevron-right"
        (onClick)="navigateCalendarMonth(1)"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Next Month'"
        size="small" />
    </div>
    
    <div class="calendar-grid compact">
      <div class="calendar-header compact">
        <div class="calendar-day-header compact" *ngFor="let dayName of ['S', 'M', 'T', 'W', 'T', 'F', 'S']">
          {{ dayName }}
        </div>
      </div>
      <div class="calendar-body compact">
        <div
          class="calendar-day compact"
          [class.empty]="day.day === 0"
          [class.weekend]="day.day > 0 && isWeekend(day.date)"
          [class.clickable]="day.count > 0"
          [class.has-data]="day.count > 0"
          [ngClass]="getCalendarDayStatusClass(day)"
          (click)="onDateClick(day)"
          *ngFor="let day of calendarDays"
          [pTooltip]="getDayTooltip(day)">
          <div class="day-number compact" *ngIf="day.day > 0">{{ day.day }}</div>
          <div class="day-invoices compact" *ngIf="day.count > 0">
            <span class="invoice-count">{{ day.count }}</span>
            <span class="invoice-percentage-small">{{ day.totalPercentage.toFixed(0) }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="closeCalendarDialog()" severity="secondary" />
  </ng-template>
</p-dialog>
